const getters = {
  contractor: (state) => state.contractor || '',
  contactInfo: (state) => state.contactInfo || [],
}

const mutations = {
  setContractor: (state, payload) => {
    state.contractor = payload
  },
  setContactInfo: (state, payload) => {
    state.contactInfo = payload
  },
}

const actions = {
  reset: ({ commit }) => {
    commit('setContractor', '')
    commit('setContactInfo', [])
  },
}

export default {
  state: () => ({
    contractor: '',
    contactInfo: [],
  }),
  getters,
  mutations,
  actions,
  namespaced: true,
}
